var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 0H3.83333C1.71624 0 0 1.71766 0 3.8365V19.1825C0 21.3014 1.71624 23.019 3.83333 23.019H19.1667C21.2838 23.019 23 21.3014 23 19.1825V3.8365C23 1.71766 21.2838 0 19.1667 0Z",
    fill: "#2AA8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8626 7.83005C7.90469 7.8023 9.76526 7.02253 11.1804 5.75488C12.5955 7.02253 14.4561 7.8023 16.4982 7.83005C16.5724 8.27214 16.611 8.72632 16.611 9.18951C16.611 12.7392 14.3442 15.759 11.1804 16.8782C8.01656 15.759 5.74985 12.7392 5.74985 9.18951C5.74985 8.72632 5.78845 8.27214 5.8626 7.83005ZM13.6686 10.321C13.9181 10.0713 13.9181 9.66645 13.6686 9.41676C13.4191 9.16707 13.0146 9.16707 12.7651 9.41676L10.5016 11.6822L9.5957 10.7755C9.34622 10.5258 8.94167 10.5258 8.69219 10.7755C8.4427 11.0252 8.4427 11.4301 8.69219 11.6798L10.0498 13.0385C10.2993 13.2882 10.7039 13.2882 10.9533 13.0385L13.6686 10.321Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9184dfd59ec5e990c9908362fcc90d8f.svg";
export { ForwardRef as ReactComponent };